<template>
  <div>
    <div class="bg-white border-brand-sand border-2 rounded-xl relative" v-loading="loading">
      <div class="bg-brand-light-sand px-6 py-4 text-left rounded-tl-lg rounded-tr-lg border-b-2 border-brand-sand">
        <div class="absolute top-0 left-0 right-0 flex justify-left" v-if="!loading">
          <img class="-mt-5 ml-5" :src="imgPath" />
        </div>
        <h3 class="text-xl leading-6 mt-2 font-bold text-gray-900">
          {{ name }}
        </h3>
        <p v-if="description" class="mt-1 mb-1 text-md font-medium leading-5 text-brand-brown">{{ description }}</p>
      </div>
      <div class="mx-6 my-6">
        <slot></slot>
      </div>
    </div>
    <div class="float-left" v-if="supportsRework">
      <AIReworkButton @rework="$emit('rework')" :stepGuid="guid" :blueprintGuid="blueprintGuid" :loading="loading" :canCancel="canCancelAI" />
    </div>
    <div class="float-right" v-if="!loading">
      <p class="text-sm mr-4 font-semibold text-brand-red hover:text-brand-red-dark mt-1 cursor-pointer" @click="$emit('disable')">Disable Step</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import AIReworkButton from '@/components/Builder/AIReworkButton.vue';
import { mapGetters } from 'vuex';
import { jobAffectsStep, generatingStep } from '@/helpers/ai-jobs';

export default {
  name: 'FlowBaseStep',
  components: {
    AIReworkButton,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    imgPath: {
      type: String,
      required: true,
    },
    guid: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['aiJobsInProgress', 'currentBlueprint']),
    blueprintGuid() {
      return this.currentBlueprint.guid;
    },
    // did we define an event listener @rework when instantiating this step component?
    supportsRework() {
      return this.$listeners && this.$listeners.rework;
    },
    // Does some AI job affect this step somehow? (step-rework or whole-blueprint job). If so, show loading state.
    loading() {
      if (this.aiJobsInProgress && this.aiJobsInProgress.length > 0) {
        return this.aiJobsInProgress.some((job) => jobAffectsStep(job, this.blueprintGuid, this.guid));
      }
      return false;
    },
    // Does some AI job affect this step specifically? (only step-rework). If so, show Cancel button.
    canCancelAI() {
      return this.aiJobsInProgress.some((job) => generatingStep(job, this.blueprintGuid, this.guid));
    },
  },
};
</script>
